// extracted by mini-css-extract-plugin
module.exports = {"root":"TrustedHtml_root__km2l4"};